import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { PiHandshakeDuotone } from "react-icons/pi";


import kh1 from './../media/img/kh1.jpeg'
import kh2 from './../media/img/kh2.jpeg'
import kh3 from './../media/img/kh3.jpeg'
import kh4 from './../media/img/kh4.jpg'
import kh5 from './../media/img/kh5.jpg'
import kh6 from './../media/img/kh6.jpg'
import kh7 from './../media/img/kh7.jpg'

import x_logo from './../media/img/x-logo.png'
import tg_logo from './../media/img/tg-logo.png'
import dex_logo from './../media/img/dex-logo.png'
import phantom_logo from './../media/img/phantom_logo.png'
import sol_logo from './../media/img/sol_logo.png'
import ds_logo from './../media/img/ds-logo.png'
import tt_logo from './../media/img/tik-tok.png'

import { ReactComponent as BscLogo } from './../media/img/bscscan-logo.svg';

import bm1 from './../media/img/bm1.jpg'
import bm2 from './../media/img/bm2.jpg'

import x_icon from './../media/icons/x-icon.png'
import twitter_icon from './../media/icons/twitter-icon.jpg'
import tg from './../media/icons/tg-icon.png'

import com_icon from './../media/icons/com_icon.png'
import ama_icon from './../media/icons/ama_icon.png'
import inf_icon from './../media/icons/inf_icon.png'
import earn_icon from './../media/icons/earn_icon.png'
import check_icon from './../media/icons/check_icon.png'
import eq_icon from './../media/icons/eq_icon.png'
import lock_icon from './../media/icons/lock_icon.png'
import per_icon from './../media/icons/per_icon.png'

import mail_icon from './../media/icons/mail-icon.png'
import dex_icon from './../media/icons/dex-icon.png'

import { htws } from './../utilities/about-htw'


const Home = () => {


    const [htwCount, setHtwcount] = useState(0)



    return ( 
        <div className="">

            <section id="home" className="home">
                <div className="main-frame height_100_p">
                    <div className="flex row align-center justify-center height_100_p">
                        <div className="home-text flex column justify-flex-end height_100_p">
                            {/* <img src={bwog_logo} className="home-text-logo-ant" alt="" data-aos="zoom-in" data-aos-duration="2000" /> */}
                            {/* <div className="home-head-subhead">
                                <h2>$BWOGG</h2>
                                <h3 className="text-align-center">CA: ARYCjcRpvJtiRPRMk4amjufveeaBME5d7K4stNe2pump</h3>
                            </div> */}
                            {/* <div className="flex row justify-center gap-15 mgb-30" >
                                <a href="https://x.com/Kohsolana" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={x_logo} alt="" />
                                </a>
                                <a href="https://t.me/+dbouOstH5Ns2OGVh" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={tg_logo} alt="" />
                                </a>
                                <a href="https://dexscreener.com/solana/bnbbaht8wbrz4b9mmdcehuztooadibykwiiv9xahduto" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={ds_logo} alt="" />
                                </a>
                                <a href="" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                    <img src={tt_logo} alt="" />
                                </a>
                            </div> */}
                            {/* <div className="flex row justify-center align-center gap-5 copy-address-box" data-aos="fade-up" data-aos-duration="2000">
                                <img src={copy_icon} alt="" />
                                <p>0x760539FF254A88B925fd940C8Bc01069cf76069b</p>
                            </div> */}
                            {/* <div className="flex row gap-15" data-aos="fade-up" data-aos-duration="2000">
                                <a href="" target="_blank" className='btn-1'>
                                    Buy Now
                                </a>
                                <a href="" target="_blank" className='btn-sp'>
                                    Join Community
                                </a>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>

            <section className="htb" id="htb">
                <div className="htb-frame">
                    <div className="htb-header">
                        <h2>Trust Koh. The bull run is inevitable.</h2>
                        <h3>How to buy $KOH</h3>
                    </div>
                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" >
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={phantom_logo} alt="" />
                                </div>
                                <h4>Phantom</h4>
                                <p>
                                    To swap $KOH on phantom,
                                </p>
                                <a href="https://phantom.app/download" target="_blank">Click here</a>
                            </div>
                        </div>

                        <div className="htb-item" >
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img className="htb-ton-logo" src={sol_logo} alt="" />
                                </div>
                                <h4>Buy SOL</h4>
                                <p>
                                    Buy SOL from your phantom wallet or any centralized exchange of your choice. You can also get a friend to send you SOL
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" >
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={kh4} className="riz_img" alt="" />
                                </div>
                                <h4>Swap $KOH on DEX</h4>
                                <p>
                                    Now that you have an SOL in your wallet, you can now swap SOL to KOH 
                                    on <a href="https://raydium.io/swap/?utm_source=phantom&utm_medium=list&inputMint=sol&outputMint=ARYCjcRpvJtiRPRMk4amjufveeaBME5d7K4stNe2pump" target="_blank">raydium</a> using 
                                    our Contract Address
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            {/* <video src={riz1_v} autoPlay muted loop /> */}
            {/* <seciton className="memes" id="memes">
                <div className="htb-frame">
                    <div className="cs-header">
                        <h2>WALL OF MEMES</h2>
                    </div>

                    <div className="wom-cont grid grid-column-3 grid-column-gap-20 grid-row-gap-20">
                        <div className="wom-item">
                            <img src={kh1} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={kh2} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={kh3} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={kh2} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={kh3} alt="" />
                        </div>
                        <div className="wom-item">
                            <img src={kh1} alt="" />
                        </div>
                    </div>
                </div>
            </seciton> */}

            <section className="about" id="about">
                <div className="htb-frame">
                    <div className="flex row wrap align-center">
                        <div className="about-text" >
                            {/* <h2>About Peki Inu</h2> */}
                            <h3>Meet Koh, the real sister of Moodeng!</h3>
                            <p>
                                The viral superstar who took the internet by storm! With Moodeng’s fame skyrocketing and her memecoin 
                                reaching an astounding $200M market cap, it’s now Koh’s moment to follow. Carrying on the family 
                                legacy with her own brand of wild energy and irresistible charm. Koh is poised to go even further than her famous sibling.<br /><br />

                                And together with both stars is their proud mother, Jona, ready to support Koh as she embarks on her own path to internet fame!
                            </p>

                            <a href="https://x.com/Kohsolana" className="about-btn flex row gap-15 justify-center align-center">
                               <span>Check out Tweet</span> 
                               <img src={twitter_icon} alt="" />
                            </a>
                        </div>
                        <div className="about-img" >
                            <img src={kh7} alt="" />
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="key-features">
                <div className="htb-frame">
                    <div className="cs-header">
                        <h2>WHY KOH?</h2>
                    </div>

                    <div className="grid htb-item-grid grid-column-3 row grid-column-gap-40 grid-row-gap-20 overflow-y-hidden">


                        <div className="htb-item" >
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={sol_logo} alt="" />
                                </div>
                                <h4>Solana Speed</h4>
                                <p>
                                    Faster than Brett’s lunch break.
                                </p>
                            </div>
                        </div>

                        <div className="htb-item" >
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <div className="kf-icon-box flex justify-center align-center">
                                        <img src={com_icon} className="" alt="" />
                                    </div>
                                </div>
                                <h4>Community Vibes</h4>
                                <p>
                                    Moodeng hit $200M, now it's Koh's time to carry the family legacy!
                                </p>
                            </div>
                        </div>
                        
                        <div className="htb-item" >
                            <div className="htb-item-inner">
                                <div className="flex justify-center">
                                    <img src={kh4} className="riz_img" alt="" />
                                </div>
                                <h4>Moon Potential</h4>
                                <p>
                                    Pack your bags, we’re moon-bound.
                                </p>
                            </div>
                        </div>


                    </div>
                </div>
            </section> */}

            <section className="tk" id="tk">
                <div className="htb-frame">
                    <div className="cs-header" >
                        <h2>TOKENOMICS</h2>
                        <h3>CA: ARYCjcRpvJtiRPRMk4amjufveeaBME5d7K4stNe2pump</h3>
                    </div>
                    <div className="grid grid-column-4 row grid-column-gap-50 grid-row-gap-20" >

                        <div className="tk-item" >
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={check_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Name/Ticker</h2>
                                <h3>$KOH</h3>
                            </div>
                        </div>

                        <div className="tk-item" >
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={eq_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Total Supply</h2>
                                <h3>1,000,000,000</h3>
                            </div>
                        </div>

                        <div className="tk-item" >
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={lock_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>LP Burned</h2>
                                <h3>Lp is Burned forever</h3>
                            </div>
                        </div>

                        <div className="tk-item" >
                            <div className="tk-item-inner">
                                <div className="flex justify-center">
                                    <div className="tk-icon-box flex justify-center align-center">
                                        <img src={per_icon} className="filter" alt="" />
                                    </div>
                                </div>
                                <h2>Taxes</h2>
                                <h3>0/0</h3>
                                {/* <h3>3 Marketing and Development | 1 LP</h3> */}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* <section className="roadmap" id="roadmap">
                <div className="htb-frame">
                    <div className="roadmap-header" data-aos="fade-up" data-aos-duration="2000">
                        <h3>BWOGG MAP</h3>
                    </div>

                    <div className="grid rd-item-grid row grid-column-3 grid-column-gap-30 grid-row-gap-20 overflow-y-hidden">
                        <div className="rd-item" data-aos="fade-right" data-aos-duration="2000">
                            <h3>Phase 1</h3>
                            <ul>
                                <li>Create social media awarness</li>
                                <li>Fair Launch on Pumpfun</li>
                                <li>Build community</li>
                                <li>Hold AMA Session</li>
                                <li>Hit the Ray</li>
                                <li>Launch Initial Contests and Competitions</li>
                            </ul>
                        </div>
                        
                        <div className="rd-item" data-aos="fade-up" data-aos-duration="2000">
                            <h3>Phase 2</h3>
                            <ul>
                                <li>Community Airdrop of 50M tokens</li>
                                <li>Massive meme marketing campaign</li>
                                <li>update Dexscreener</li>
                                <li>Dex Screener Ads</li>
                            </ul>
                        </div>

                        <div className="rd-item" data-aos="fade-left" data-aos-duration="2000">
                            <h3>Phase 3</h3>
                            <ul>
                                <li>#1 on SOL Trending</li>
                                <li>Fatality Volume bot</li>
                                <li>List on major platforms like dex tools and more</li>
                                <li>Continue Contests and Competitions</li>
                                <li>Continue to hold regular AMA Sessions</li>
                            </ul>
                        </div>


                    </div>
                </div>
            </section> */}

            {/* <section className="join" id="join">
                <div className="kf-frame">
                    <div className="cs-header overflow-y-hidden" >
                        <h2>Join Us</h2>
                    </div>

                    <div className="join-box">
                        <div className="flex justify-center">
                        </div>
                        <p>
                            We are on a mission to support Koh’s zoo and help pygmy hippos worldwide. You can contribute by donating to our wallet. 
                            Half of the funds will go directly to conservation efforts, while the other half will be used for marketing to 
                            spread the word. All donations will be securely managed through a multisig wallet by the Koh team.
                        </p>
                        <h4>Marketing Wallet: Bi1jWfc86pi4ncWQyAXKiP55kZqp3C2YgiNjtBd7ewWg</h4>
                        <a href="https://t.me/+dbouOstH5Ns2OGVh" target="_blank" className="btn-1">Telegram</a>
                    </div>
                </div>
            </section> */}

            <section className="footer" id="footer">
                <div className="main-container">
                    
                        <div className="footer-box ">
                            <h2>KOH - MOODENGS' SIS</h2>
                            {/* <h3>Verified by zoo and news article</h3> */}
                            <div className="flex justify-center">
                                <div className="flex row gap-15 mgb-30" >
                                    <a href="https://x.com/Kohsolana" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={x_logo} alt="" />
                                    </a>
                                    <a href="https://t.me/+dbouOstH5Ns2OGVh" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tg_logo} alt="" />
                                    </a>
                                    {/* <a href="mailto:dhurovcoin@gmail.com" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={mail_icon} alt="" />
                                    </a> */}
                                    <a href="https://dexscreener.com/solana/bnbbaht8wbrz4b9mmdcehuztooadibykwiiv9xahduto" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={ds_logo} alt="" />
                                    </a>
                                    <a href="" target="_blank" className="home-ct-icon-box flex justify-center align-center">
                                        <img src={tt_logo} alt="" />
                                    </a>
                                </div>
                            </div>
                            <p className="copyright">KOH copyright 2024 - All Rights Reserved</p>
                    </div>

                    {/* <hr /> */}
                </div>
            </section>

        </div>
    );
}
 
export default Home;